import type { LegDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { getPtModeIconName } from '@/utils/icon';
import { Icons } from '@fleet/webshop-ui';

export const TransportationTypeIcon = ({
  ptMode,
  width = 16,
  height = 16,
  className,
}: {
  ptMode: LegDTO['ptMode'];
  width?: number;
  height?: number;
  className?: string;
}) => {
  const iconName = getPtModeIconName(ptMode);
  const IconComponent = Icons[iconName];

  return (
    <IconComponent
      width={width}
      height={height}
      className={cn(className, { ['scale-[0.80]']: iconName === 'bus' })}
    />
  );
};
